"use client"
import classNames from "classnames";
import { useEffect, useState } from "react";
import CloseSvg from "src/components/svg/CloseSvg";
import getURLParameter from "src/lib/client/getURLParameter";
import { useAdContext } from "src/lib/types/ads/AdContextType";
import styles from "./Ad.module.css";
import { locale } from "@locale";
import type { AdProps } from "src/components/ads/AdProps";

const _handledOnMount = new Set<string>();

//#region [Component]
export default function FilmwebAd({ targetId, className, supportsFixedAd = false, canHide = false, removeIfNoAd = false, height, mobileScreenWidth = false, isPixel = false, noHeader = false, refreshKey, style }: AdProps) {
    const [hasLoadedAd, setHasLoadedAd] = useState(!removeIfNoAd);
    const [hasNoAds, setHasNoAds] = useState(false);
    const [closeAd, setCloseAd] = useState(false);
    const adContext = useAdContext();


    // enkel “nå er jeg rendret”-logg (valgfritt, men nyttig)
    //console.log("[AD]", targetId, "render; refreshKey =", refreshKey);

    useEffect(() => {
        // remove ads so we can test a page without it
        const skipAds = getURLParameter("skipAds");
        if (skipAds && skipAds === "true") {
            // eslint-disable-next-line react-hooks/set-state-in-effect -- the skipAds URL parameter is only known in the browser, so it is read after hydration
            setHasNoAds(true);
            setHasLoadedAd(true);
        }
    }, []);


    // refresh én gang per (slotId + refreshKey)
    useEffect(() => {
        const key = refreshKey?.trim?.() || "";
        if (key) {
            const combo = `${targetId}|${key}`;
            if (_handledOnMount.has(combo)) {
                //console.log("[AD]", targetId, "mount with same key already handled → skip");
            } else {
                _handledOnMount.add(combo);
                console.log("[AD]", targetId, "mount → refresh() with key:", key);
                adContext?.refresh?.();
            }
        } else {
            //console.log("[AD]", targetId, "mount (no refreshKey) → no refresh");
        }
    }, [targetId, refreshKey, adContext]);


    useEffect(() => {
        // remove the ad if the user wants it gone by clicking the close button
        if (removeIfNoAd && closeAd && typeof window !== "undefined") {
            setTimeout(() => {
                setHasNoAds(true);
            }, 500);
        }
    }, [closeAd, removeIfNoAd]);

    // once the ad context reports the ad as loaded it stays loaded (adjusted during render, not in an effect)
    if (!hasLoadedAd && adContext.loadedAds.includes(targetId)) {
        console.log("[AD]", targetId, "marked loaded via adContext");
        setHasLoadedAd(true);
    }

    if (removeIfNoAd && hasNoAds) {
        console.log("[AD]", targetId, "removeIfNoAd=true → returning null");
        return null;
    }

    return <div className={classNames(className,
        styles.SMinimalAdWrapper,
        "SMinimalAdWrapper",
        {
            [styles.SAdWrapper]: !noHeader,
            [styles.hide]: canHide && !hasLoadedAd,
            [styles['mobile-screen-width']]: mobileScreenWidth
        })} style={style}>
        <div className={classNames("adContainer", styles.SAdContainer, {
            [styles.noHeaders]: noHeader,
            [styles.hide]: canHide && !hasLoadedAd,
            [styles.pixel]: isPixel
        })}>
            {!isPixel && !noHeader && <div className={classNames("adHeading", styles.SAdHeading)}>{locale.ads.adLabel}</div>}
            <div
                className={classNames("adContent",
                    styles.SAdContent,
                    {
                        [styles['supports-fixed-ad']]: supportsFixedAd,
                        [styles['height-300']]: height?.toString() === "300"
                    })}
            //$isLoaded={hasLoadedAd}
            >
                <div id={targetId} className="adnun"></div>
                {!isPixel && canHide && hasLoadedAd && <button className={styles.SAdCloser}
                    aria-label={locale.ads.hideAd}
                    title={locale.ads.hideAd}
                    onClick={() => setCloseAd(true)}><CloseSvg className={styles.SCloseSvg} /></button>}
            </div>
        </div>
    </div>;
}
//#endregion